// extracted by mini-css-extract-plugin
module.exports = {"container":"EntitySettings_container__VTKSA","nav_container":"EntitySettings_nav_container__2OVni","content_container":"EntitySettings_content_container__1pPQ1"};